<template lang="html">
  <div>
    <van-image
      :fit="fit"
      :height="height"
      :width="width"
      :radius="radius"
      :src="src"
      style="display:block;-webkit-touch-callout:none;"
      @click="click"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Image } from 'vant'
  Vue.use(Image)
  export default {
    props: {
      source: String,
      imgId: Number,
      height: {
        type: String,
        default: '150px'
      },
      width: {
        type: String,
        default: ''
      },
      radius: {
        type: String,
        default: ''
      },
      fit: {
        type: String,
        default: 'cover'
      }
    },
    data () {
      return {
        src: ''
      }
    },
    methods: {
      click () {
        this.$emit("preview", this.src)
      }
    },
    watch: {
    },
    mounted () {
      let that = this
      that.$api.image.detail(this.imgId).then(res => {
        window.console.log("获得图片信息：")
        window.console.log(res)
        // this.src = res.data.upload
        let src
        switch (that.source) {
          case 'local': src = res.data.upload
          break;
          case 'cdn': src = res.data.private_cdns[0].cdn_url
          break;
          default: src = res.data.upload
        }
        that.src = src
        that.$emit("photo-gotten", that.src)
      })
    }
  }
</script>

<style lang="css" scoped>
</style>
